import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";
import { EditableText } from "../../EditableText";
import type { PDFPreviewFormData } from "../pdfPreview.types";

interface PDFTermsFooterEditorProps {
  control: Control<PDFPreviewFormData>;
}

export function PDFTermsFooterEditor({ control }: PDFTermsFooterEditorProps) {
  return (
    <>
      {/* Terms */}
      <Controller
        name="terms"
        control={control}
        render={({ field: { onChange, value } }) =>
          value ? (
            <div className="mt-6">
              <EditableText
                value={value}
                onChange={onChange}
                displayAs="p"
                inputType="textarea"
                displayClassName="text-sm"
                editClassName="text-sm w-full min-h-[60px] resize-y"
              />
            </div>
          ) : (
            <></>
          )
        }
      />

      {/* Footer Lines */}
      <Controller
        name="footerLines"
        control={control}
        render={({ field: { value: footerLines, onChange } }) =>
          footerLines && footerLines.length > 0 ? (
            <div className="mt-6">
              {footerLines.map((line, index) => (
                <div key={index}>
                  <EditableText
                    value={line}
                    onChange={(newValue) => {
                      const updated = [...footerLines];
                      updated[index] = newValue;
                      onChange(updated);
                    }}
                    displayAs="p"
                    displayClassName="text-sm"
                    editClassName="text-sm w-full"
                  />
                </div>
              ))}
            </div>
          ) : (
            <></>
          )
        }
      />
    </>
  );
}
